import { FC } from "react";
// styles
import styles from "styles/typography.module.scss";

export type TDocumentHeaderSplitterProps = {
    title: string
};

export const DocumentHeaderSplitter: FC<TDocumentHeaderSplitterProps> = ({ title }: TDocumentHeaderSplitterProps) => {
    return (
        <h5 className={styles.listHeader}>{title}</h5>
    );
};